import { bannerData } from "../../../globals/banner";
import Banner from "../../sections/common/banner";
import SectionInsightDetailInner from "../../sections/insights/detail/section-insight-detail-inner";
import { useParams } from "react-router-dom";
import { blogPosts } from "../../../globals/neuron-content";

function InsightDetailPage() {
    const { slug } = useParams();
    const index = blogPosts.findIndex((post) => post.slug === slug);
    const currentPost = index >= 0 ? blogPosts[index] : blogPosts[0];
    const currentIndex = index >= 0 ? index : 0;

    return (
        <>
            <Banner _data={bannerData.insightDetail} />

            {/* SECTION CONTENT START */}
            <div className="section-full p-t100 p-b70 mobile-page-padding">
                <div className="container">
                    <div className="blog-single-space-wrap max-w800 m-lr-auto">
                        <SectionInsightDetailInner currentPost={currentPost} currentIndex={currentIndex} />
                    </div>
                </div>
            </div>
            {/* SECTION CONTENT END */}
        </>
    )
}
export default InsightDetailPage;
